import axios from 'axios';

// Nếu bạn đang có axios instance riêng thì thay bằng instance đó.
// Ví dụ: import api from './apiClient' ...
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || 'http://localhost:3000', // hoặc để '' nếu cùng domain
});

export async function getHomepageConfig() {
  const res = await api.get('/webtool/homepage');
  return res.data;
}

export async function updateHomepageConfig(sections) {
  const res = await api.put('/webtool/homepage', { sections });
  return res.data;
}